export default __webpack_public_path__ + "images/onboarding-slide-1.f42346b5adcc49fa0e1f240a1000cb2d.svg";